console.log('js/currencies_converter.js -> v0.1.0');
$(function() {
  return $('body').on('click', '.currency-option', function(event) {
    var chosen_option, data, listing_id, package_id, url, toUrl;
    event.preventDefault();
    chosen_option = $(this).data('currencyCode');
    url = $("#currencies-options").data("setCurrencyConvertTo");
	toUrl = $(this).attr('href');
    data = $('#original-price-wrapper').length ? (package_id = $('#original-price-wrapper').data("packageId"), listing_id = $('#original-price-wrapper').data("listingId"), {
		currency_convert_to: chosen_option,
		listing_id: listing_id,
		package_id: package_id
    }) : {
		currency_convert_to: chosen_option
    };
    return $.ajax({
		type: 'POST',
		data: data,
		url: url
		}).done(function() {
			// true => fetch from server, not browser cache
			//TODO(Artem): get rid of this hack. Subscribe to events? Make it a separate control?
			let currentUrl = toUrl;

			/* Remove param that forces currency convertion, otherwise keeping the param in the url
				would "invalidate the user action of changing the currency. */
			if(currentUrl.indexOf("currency_convert_to") >= 0) {
				currentUrl = removeUrlParameter("currency_convert_to", currentUrl);
			}

      // Check for slider experiment params and remove them
      if (location.href.indexOf("price_limit_lower") >= 0 || location.href.indexOf("price_limit_upper") >= 0) {
        currentUrl = removeUrlParameter("price_limit_lower", currentUrl);
        currentUrl = removeUrlParameter("price_limit_upper", currentUrl);
      }

			if (isSearchresultsPage){
				currentUrl = removeUrlParameter("price_min", currentUrl);
				currentUrl = removeUrlParameter("price_max", currentUrl);
			} else if (location.href.indexOf("lower") >= 0 || location.href.indexOf("higher") >= 0) { // sf_bas_price_filters
				currentUrl = removeUrlParameter("lower", currentUrl);
				currentUrl = removeUrlParameter("higher", currentUrl);
			}

			if(currentUrl === location.href) {
				location.reload(true);
			} else {
				location.href = currentUrl;
			}
	});
  });
});
